import { render, staticRenderFns } from "./LivingOptionsPackages.vue?vue&type=template&id=4687a61e"
import script from "./LivingOptionsPackages.vue?vue&type=script&lang=js"
export * from "./LivingOptionsPackages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports